// extracted by mini-css-extract-plugin
module.exports = {"root":"CosmeticCreateEdit_root__3F2ZQ"};